import React, { useEffect, useRef, useState } from "react";
import { Container, Images, Risk, Risks, Image, RiskItem } from "./styles";
import { useParams } from "react-router-dom";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { useMediaQuery } from "react-responsive";
import logoBranca from "./../../../images/logoBranca.png";
import { format } from "date-fns";
import { Button, Input, Modal, Spin } from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";
import html2pdf from "html2pdf.js";
import { useAuth } from "../../../hooks/AuthContext";
import Status from "../../../components/status";

const { confirm } = Modal;

export default function Company() {
  const { user } = useAuth();
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1200px)",
  });

  const contentRef = useRef();

  const { company_id } = useParams();

  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState(0);
  const [totalM, setTotalM] = useState(0);
  const [company, setCompany] = useState([]);
  const [error, setError] = useState("");
  const [integrating, setIntegrating] = useState("");
  const [visibleModalLink, setVisibleModalLink] = useState(false);
  const [visibleModalLinkSector, setVisibleModalLinkSector] = useState(false);
  const [activeSector, setActiveSector] = useState(null);
  const [sgg_id, setSgg_id] = useState("");
  const [visibleModalAlteration, setVisibleModalAlteration] = useState(false);
  const [observation, setObservation] = useState("");
  const [requestingAlteration, setRequestingAlteration] = useState(false);

  useEffect(() => {
    loadingCompany();
  }, []);

  async function requestAlteration() {
    if (!observation) {
      toast.warn("Por favor, digite a observação para a alteração");
      return;
    }
    setRequestingAlteration(true);
    await api
      .put(`/company-handler/${company_id}`, {
        observation: observation,
      })
      .then(() => {
        toast.success("Alteração solicitada com sucesso");
        setVisibleModalAlteration(false);
        loadingCompany();
      })
      .catch(({ response }) => {
        if (response && response.data && response.data.message) {
          toast.warn(response.data.message);
        } else {
          toast.error("Erro ao solicitar alteração");
        }
      });
    setRequestingAlteration(false);
  }

  async function linkCompany() {
    if (!sgg_id) {
      toast.warn("Digite o código SGG da empresa");
      return;
    }
    setIntegrating(`link-company`);
    await api
      .put(`/sgg/company/${company_id}`, {
        sgg_id: sgg_id,
      })
      .then((response) => {
        toast.success("Vínculo realizado com sucesso");
        setVisibleModalLink(false);
        loadingCompany();
      })
      .catch(({ response }) => {
        if (response && response.data && response.data.message) {
          toast.warn(response.data.message);
        } else {
          toast.error("Erro ao realizar vínculo");
        }
      });
    setIntegrating("");
  }

  async function linkSector() {
    if (!sgg_id) {
      toast.warn("Digite o código SGG do setor");
      return;
    }
    setIntegrating(`link-sector`);
    await api
      .put(`/sgg/sector/${activeSector.id}`, {
        sgg_id: sgg_id,
      })
      .then((response) => {
        toast.success("Vínculo realizado com sucesso");
        setVisibleModalLinkSector(false);
        loadingCompany();
      })
      .catch(({ response }) => {
        if (response && response.data && response.data.message) {
          toast.warn(response.data.message);
        } else {
          toast.error("Erro ao realizar vínculo");
        }
      });
    setIntegrating("");
  }

  async function integrationCompany() {
    setIntegrating(`company`);
    await api
      .post(`/sgg-company/${company_id}`, {
        razao_social: company.razao_social,
        cnpj: company.cnpj,
        nome_fantasia: company.nome_fantasia,
      })
      .then((response) => {
        toast.success("Integração realizada com sucesso");
        loadingCompany();
      })
      .catch(({ response }) => {
        if (response && response.data && response.data.message) {
          toast.warn(response.data.message);
        } else {
          toast.error("Erro ao realizar integração");
        }
      });
    setIntegrating("");
  }

  async function integrationSetor(sector) {
    setIntegrating(`sector-${sector.id}`);
    await api
      .post(`/sgg-sector/${sector.id}`, {
        setor: sector.name,
        company_id: company.id,
        descricao_ambiente: sector.description,
      })
      .then((response) => {
        toast.success("Integração realizada com sucesso");
        loadingCompany();
      })
      .catch(({ response }) => {
        if (response && response.data && response.data.message) {
          toast.warn(response.data.message);
        } else {
          toast.error("Erro ao realizar integração");
        }
      });
    setIntegrating("");
  }

  async function integrationFuncao(employee) {
    setIntegrating(`employee-${employee.id}`);
    await api
      .post(`/sgg-employee/${employee.id}`, {
        company_id: company.id,
      })
      .then((response) => {
        toast.success("Integração realizada com sucesso");
        loadingCompany();
      })
      .catch(({ response }) => {
        if (response && response.data && response.data.message) {
          toast.warn(response.data.message);
        } else {
          toast.error("Erro ao realizar integração");
        }
      });
    setIntegrating("");
  }

  async function integrationRisks(sector) {
    setIntegrating(`risks-${sector.id}`);
    await api
      .post(`/sgg-risks/${sector.id}`, {
        company_id: company.id,
      })
      .then((response) => {
        toast.success("Integração realizada com sucesso");
        loadingCompany();
      })
      .catch(({ response }) => {
        if (response && response.data && response.data.message) {
          toast.warn(response.data.message);
        } else {
          toast.error("Erro ao realizar integração");
        }
      });
    setIntegrating("");
  }

  async function loadingCompany() {
    await api
      .get(`/company/${company_id}`)
      .then((response) => {
        setCompany(response.data);
        let total = 0;
        let totalM = 0;
        response.data.companySector.map((item) => {
          item.companyEmployees.map((data) => {
            total += parseInt(data.quantidade_colaboradores) || 0;
            totalM += parseInt(data.quantidade_colaboradores_m) || 0;
          });
        });
        setTotal(total);
        setTotalM(totalM);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              setError(response.data.message);
              toast.warn(response.data.message);
            } else {
              setError("Erro Interno. verifique sua conexão e tente novamente");
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            setError("Erro Interno. verifique sua conexão e tente novamente");
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          setError("Erro Interno. verifique sua conexão e tente novamente");
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setLoading(false);
  }

  const handleGeneratePdf = () => {
    const element = contentRef.current; // O elemento que queremos converter

    const options = {
      margin: 10,
      filename: `formulario-levantamento-${company_id}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true }, // scale 2 melhora a resolução
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    };

    // Gera e baixa o PDF
    html2pdf().set(options).from(element).save();
  };

  return (
    <Container
      style={{
        minHeight: 80,
      }}
    >
      {!loading && (
        <div
          style={{
            width: "100%",
            maxWidth: 1000,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: 30,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
            <Status status={company.status} />
            {user?.type === "tecnico" && company.status !== "alteracao" && (
              <Button
                type="primary"
                onClick={() => {
                  setObservation("");
                  setVisibleModalAlteration(true);
                }}
              >
                Solicitar Alteração
              </Button>
            )}
          </div>
          <Button type="primary" shape="round" onClick={handleGeneratePdf}>
            Baixar PDF
          </Button>
        </div>
      )}

      <Container ref={contentRef}>
        {loading ? (
          <Spin size="large" style={{ marginTop: 50 }} />
        ) : (
          <>
            {error ? (
              <h3 style={{ marginTop: 100, textAlign: "center" }}>{error}</h3>
            ) : (
              <div
                style={
                  isDesktopOrLaptop
                    ? { padding: "20px", flexDirection: "column" }
                    : { maxWidth: "92%", width: "92%", flexDirection: "column" }
                }
              >
                <img src={logoBranca} />
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <h3 style={{ margin: 0 }}>Formulário EMPRESA</h3>
                  {user?.type === "tecnico" && (
                    <div style={{ display: "flex", gap: "10px" }}>
                      {!company.sgg_id && (
                        <Button
                          type="primary"
                          onClick={() => {
                            setSgg_id("");
                            setVisibleModalLink(true);
                          }}
                        >
                          Vincular Código SGG
                        </Button>
                      )}
                      <Button
                        type="primary"
                        loading={integrating === `company`}
                        onClick={() => {
                          if (!company.sgg_id) {
                            confirm({
                              title: "Deseja integrar os dados da empresa?",
                              icon: <ExclamationCircleFilled />,
                              content:
                                "Essa ação enviará os dados da empresa para o SGG.",
                              okText: "Sim, integrar",
                              cancelText: "Cancelar",
                              onOk() {
                                integrationCompany("company");
                              },
                            });
                          }
                        }}
                        style={
                          company.sgg_id
                            ? { opacity: 0.7, cursor: "not-allowed" }
                            : {}
                        }
                      >
                        {company.sgg_id
                          ? `Id Empresa: ${company.sgg_id}`
                          : "Integrar Dados da Empresa"}
                      </Button>
                    </div>
                  )}
                </div>
                {company.observation && (
                  <>
                    <h4 style={{ margin: "20px 0 10px 0", color: company.status === "alteracao" ? "#FFBB45" : "inherit" }}>
                      {company.status === "alteracao"
                        ? "MOTIVO DA ALTERAÇÃO SOLICITADA PELO TÉCNICO"
                        : "OBSERVAÇÃO DO FRANQUEADO"}
                    </h4>
                    <div
                      style={{
                        width: "100%",
                        padding: 15,
                        background:
                          company.status === "alteracao" ? "#fffbe6" : "#f0f0f0",
                        borderLeft:
                          company.status === "alteracao" ? "4px solid #FFBB45" : "none",
                        borderRadius:
                          company.status === "alteracao" ? "0 10px 10px 0" : 10,
                        marginBottom: 20,
                        whiteSpace: "pre-wrap",
                        fontWeight: "bold",
                      }}
                    >
                      {company.observation}
                    </div>
                  </>
                )}
                <h4 style={{ margin: "20px 0 0 0" }}>DADOS DA EMPRESA</h4>
                <span style={{ margin: "20px 0 10px 0" }}>
                  Razão Social: <strong>{company.razao_social}</strong>
                </span>
                <span style={{ margin: "5px 0 10px 0" }}>
                  Nome Fantasia: <strong>{company.nome_fantasia}</strong>
                </span>
                <span style={{ margin: "5px 0 10px 0" }}>
                  {company.type}: <strong>{company.cnpj}</strong>
                </span>
                <span style={{ margin: "5px 0 10px 0" }}>
                  Ramo de Atividade: <strong>{company.ramo_atividade}</strong>
                </span>
                <span style={{ margin: "5px 0 10px 0" }}>
                  CEP: <strong>{company.cep}</strong>
                </span>
                <span style={{ margin: "5px 0 10px 0" }}>
                  Endereço: <strong>{company.endereco}</strong>
                </span>
                <h4 style={{ margin: "20px 0 15px 0" }}>RESPONSÁVEL</h4>
                <span style={{ margin: "5px 0 10px 0" }}>
                  Nome do Responsável Assinante:{" "}
                  <strong>{company.nome_responsavel}</strong>
                </span>
                <span style={{ margin: "5px 0 10px 0" }}>
                  Número do CPF do Representante:{" "}
                  <strong>{company.cpf_responsavel}</strong>
                </span>
                <span style={{ margin: "5px 0 10px 0" }}>
                  Contato do Representante:{" "}
                  <strong>{company.contato_responsavel}</strong>
                </span>
                {company.companySector.map((item, index) => {
                  return (
                    <>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          width: "100%",
                          marginTop: 20,
                          marginBottom: 10,
                        }}
                      >
                        <h4 style={{ margin: 0 }}>SETOR {index + 1}</h4>
                        {user?.type === "tecnico" && (
                          <div style={{ display: "flex", gap: "10px" }}>
                            {!item.sgg_id && (
                              <Button
                                type="primary"
                                onClick={() => {
                                  setSgg_id("");
                                  setActiveSector(item);
                                  setVisibleModalLinkSector(true);
                                }}
                              >
                                Vincular Código SGG
                              </Button>
                            )}
                            <Button
                              type="primary"
                              loading={integrating === `sector-${item.id}`}
                              onClick={() => {
                                if (!item.sgg_id) {
                                  confirm({
                                    title: "Deseja integrar este setor?",
                                    icon: <ExclamationCircleFilled />,
                                    content: `O setor "${item.name}" será integrado ao SGG.`,
                                    okText: "Sim, integrar",
                                    cancelText: "Cancelar",
                                    onOk() {
                                      integrationSetor(item);
                                    },
                                  });
                                }
                              }}
                              style={
                                item.sgg_id
                                  ? { opacity: 0.7, cursor: "not-allowed" }
                                  : {}
                              }
                            >
                              {item.sgg_id
                                ? `Id Setor: ${item.sgg_id}`
                                : "Integrar Setor"}
                            </Button>
                          </div>
                        )}
                      </div>
                      <span style={{ margin: "5px 0 0px 0" }}>
                        Nome: <strong>{item.name}</strong>
                      </span>
                      <span style={{ margin: "5px 0 10px 0" }}>
                        Descrição do Ambiente:{" "}
                        <strong>{item.description}</strong>
                      </span>
                      {item.companyEmployees.map((data, index) => {
                        return (
                          <>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                width: "100%",
                                marginTop: 20,
                                marginBottom: 10,
                              }}
                            >
                              <h5 style={{ margin: 0 }}>FUNÇÃO {index + 1}</h5>
                              {user?.type === "tecnico" && (
                                <Button
                                  type="primary"
                                  loading={
                                    integrating === `employee-${data.id}`
                                  }
                                  onClick={() => {
                                    if (!data.sgg_id) {
                                      confirm({
                                        title: "Deseja integrar esta função?",
                                        icon: <ExclamationCircleFilled />,
                                        content: `A função "${data.name}" será integrada ao SGG.`,
                                        okText: "Sim, integrar",
                                        cancelText: "Cancelar",
                                        onOk() {
                                          integrationFuncao(data);
                                        },
                                      });
                                    }
                                  }}
                                  style={
                                    data.sgg_id
                                      ? { opacity: 0.7, cursor: "not-allowed" }
                                      : {}
                                  }
                                >
                                  {data.sgg_id
                                    ? `Id Função: ${data.sgg_id}`
                                    : "Integrar Função"}
                                </Button>
                              )}
                            </div>
                            <span style={{ margin: "5px 0 0px 0" }}>
                              Nome: <strong>{data.name}</strong>
                            </span>
                            <span style={{ margin: "5px 0 0px 0" }}>
                              CBO: <strong>{data.cbo}</strong>
                            </span>
                            <span style={{ margin: "5px 0 0px 0" }}>
                              Descrição das Atividades:{" "}
                              <strong>{data.description}</strong>
                            </span>
                            <span style={{ margin: "5px 0 0px 0" }}>
                              EPIS usados na função:{" "}
                              <strong>{data.epis}</strong>
                            </span>
                            <span
                              style={{
                                margin: "10px 0 5px 0",
                                display: "flex",
                                justifyContent: "space-between",
                                flexWrap: "wrap",
                                alignItems: "center",
                                width: "100%",
                              }}
                            >
                              <span
                                style={{
                                  background: "#e8f5e9",
                                  color: "#2e7d32",
                                  padding: "6px 8px",
                                  borderRadius: "12px",
                                  fontSize: "11px",
                                  fontWeight: "600",
                                  border: "1px solid #c8e6c9",
                                  width: "30%",
                                  textAlign: "center",
                                  display: "inline-block",
                                  boxSizing: "border-box",
                                }}
                              >
                                Colaboradores: {data.quantidade_colaboradores}
                              </span>
                              <span
                                style={{
                                  background: "#e3f2fd",
                                  color: "#1565c0",
                                  padding: "6px 8px",
                                  borderRadius: "12px",
                                  fontSize: "11px",
                                  fontWeight: "600",
                                  border: "1px solid #bbdefb",
                                  width: "30%",
                                  textAlign: "center",
                                  display: "inline-block",
                                  boxSizing: "border-box",
                                }}
                              >
                                Masculinos:{" "}
                                {data.quantidade_colaboradores_m || 0}
                              </span>
                              <span
                                style={{
                                  background: "#fce4ec",
                                  color: "#c2185b",
                                  padding: "6px 8px",
                                  borderRadius: "12px",
                                  fontSize: "11px",
                                  fontWeight: "600",
                                  border: "1px solid #f8bbd0",
                                  width: "30%",
                                  textAlign: "center",
                                  display: "inline-block",
                                  boxSizing: "border-box",
                                }}
                              >
                                Femininos:{" "}
                                {data.quantidade_colaboradores_f || 0}
                              </span>
                            </span>
                          </>
                        );
                      })}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          width: "100%",
                          marginTop: 20,
                          marginBottom: 10,
                        }}
                      >
                        <h5 style={{ margin: 0 }}>RISCOS DO SETOR</h5>
                        {user?.type === "tecnico" && (
                          <Button
                            type="primary"
                            loading={integrating === `risks-${item.id}`}
                            onClick={() => {
                              if (!item.sgg_risks_id) {
                                const allIntegrated =
                                  item.companyScratchs.every((r) => r.sgg_id);
                                if (!allIntegrated) {
                                  confirm({
                                    title:
                                      "Deseja integrar os riscos do setor?",
                                    icon: <ExclamationCircleFilled />,
                                    content:
                                      "Todos os riscos deste setor serão enviados para o SGG.",
                                    okText: "Sim, integrar",
                                    cancelText: "Cancelar",
                                    onOk() {
                                      integrationRisks(item);
                                    },
                                  });
                                }
                              }
                            }}
                            style={
                              item.sgg_risks_id
                                ? { opacity: 0.7, cursor: "not-allowed" }
                                : {}
                            }
                          >
                            {item.sgg_risks_id
                              ? `Avaliação de Risco: ${item.sgg_risks_id}`
                              : "Integrar Riscos"}
                          </Button>
                        )}
                      </div>
                      <Risks>
                        {item.companyScratchs.map((risk, riskIndex) => {
                          return (
                            <RiskItem key={riskIndex}>
                              <div className="risk-info">
                                <p style={{ margin: 0, marginBottom: 5 }}>
                                  <strong>
                                    Risco {risk.type} - {risk.name}
                                  </strong>
                                </p>
                                {risk.sgg_id && (
                                  <p style={{ margin: "5px 0" }}>
                                    Id Risco: <strong>{risk.sgg_id}</strong>
                                  </p>
                                )}
                                <p>
                                  <strong>Atividades/Processos:</strong>{" "}
                                  {risk.description}
                                </p>
                                {risk.fonte_geradora && (
                                  <p>
                                    <strong>Fonte Geradora:</strong>{" "}
                                    {risk.fonte_geradora}
                                  </p>
                                )}
                                {risk.perigos && (
                                  <p>
                                    <strong>Perigos:</strong> {risk.perigos}
                                  </p>
                                )}
                                {(risk.probabilidade || risk.efeito) && (
                                  <p>
                                    <strong>Avaliação de Risco:</strong> (
                                    {risk.probabilidade} x {risk.efeito})
                                  </p>
                                )}
                                {risk.epis && (
                                  <p>
                                    <strong>EPIs:</strong> {risk.epis}
                                  </p>
                                )}
                                {risk.epcs && (
                                  <p>
                                    <strong>EPCs:</strong> {risk.epcs}
                                  </p>
                                )}
                                {risk.medidas_controle && (
                                  <p>
                                    <strong>Medidas de Controle:</strong>{" "}
                                    {risk.medidas_controle}
                                  </p>
                                )}
                                {risk.tipo_exposicao && (
                                  <p>
                                    <strong>Tipo de Exposição:</strong>{" "}
                                    {risk.tipo_exposicao}
                                  </p>
                                )}
                                {risk.tempo_exposicao && (
                                  <p>
                                    <strong>Tempo de Exposição:</strong>{" "}
                                    {risk.tempo_exposicao}
                                  </p>
                                )}
                              </div>
                            </RiskItem>
                          );
                        })}
                      </Risks>
                      {!!company.companyImages[index].length && (
                        <>
                          <h5 style={{ margin: "20px 0 0 0" }}>
                            IMAGENS DO SETOR
                          </h5>
                          <Images style={{ justifyContent: "flex-start" }}>
                            {company.companyImages[index].map((item) => {
                              return (
                                <Image>
                                  <a href={item.photo_url} target="_blank">
                                    <img src={item.photo_url} />
                                  </a>
                                </Image>
                              );
                            })}
                          </Images>
                        </>
                      )}
                    </>
                  );
                })}

                <div
                  style={{
                    background: "#ffffff",
                    border: "1px solid #e0e0e0",
                    borderRadius: "12px",
                    padding: "20px 24px",
                    margin: "35px 0",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexWrap: "wrap",
                    gap: "20px",
                    width: "100%",
                    boxSizing: "border-box",
                  }}
                >
                  <div style={{ flex: 1, minWidth: "250px" }}>
                    <span
                      style={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        color: "#333",
                        display: "block",
                      }}
                    >
                      Resumo do Quadro de Funcionários
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      minWidth: "220px",
                      width: "100%",
                      maxWidth: "300px",
                    }}
                  >
                    <span
                      style={{
                        background: "#e8f5e9",
                        color: "#2e7d32",
                        padding: "8px 16px",
                        borderRadius: "8px",
                        fontSize: "14px",
                        fontWeight: "bold",
                        border: "1px solid #c8e6c9",
                        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.02)",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: "20px",
                      }}
                    >
                      <span>Total:</span>
                      <strong>{total}</strong>
                    </span>
                    <span
                      style={{
                        background: "#e3f2fd",
                        color: "#1565c0",
                        padding: "8px 16px",
                        borderRadius: "8px",
                        fontSize: "14px",
                        fontWeight: "bold",
                        border: "1px solid #bbdefb",
                        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.02)",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: "20px",
                      }}
                    >
                      <span>Masculinos:</span>
                      <strong>{totalM}</strong>
                    </span>
                    <span
                      style={{
                        background: "#fce4ec",
                        color: "#c2185b",
                        padding: "8px 16px",
                        borderRadius: "8px",
                        fontSize: "14px",
                        fontWeight: "bold",
                        border: "1px solid #f8bbd0",
                        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.02)",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: "20px",
                      }}
                    >
                      <span>Femininos:</span>
                      <strong>{total - totalM || 0}</strong>
                    </span>
                  </div>
                </div>

                <h4 style={{ textAlign: "center", margin: "35px 0 5px 0" }}>
                  Guruseg Gestão e Treinamentos em Segurança do Trabalho:
                </h4>
                <a>www.guruseg.com.br</a>
                <h4 style={{ textAlign: "center", marginTop: 35 }}>
                  Apresentação:
                </h4>
                <span style={{ textAlign: "center", margin: "35px 0" }}>
                  Somos uma empresa especializada em Segurança do Trabalho
                  formada por Médicos especializados e uma equipe
                  multidisciplinar (Médicos, Engenheiros e Técnicos), focada na
                  qualidade agilidade dos serviços prestados aos nossos
                  clientes, somos referência em todo Brasil. Atuando na área de
                  Gestão ao E-social, elaboração e documentos, Treinamentos e
                  muito mais, contamos com unidades Franqueadas em todos os
                  estados Brasileiro.
                </span>
              </div>
            )}
          </>
        )}{" "}
      </Container>
      {user?.type === "tecnico" && (
        <Modal
          title="Vincular Código SGG"
          open={visibleModalLink}
          onOk={linkCompany}
          onCancel={() => setVisibleModalLink(false)}
          confirmLoading={integrating === "link-company"}
          okText="Vincular"
          cancelText="Cancelar"
        >
          <div style={{ padding: "20px 0" }}>
            <p>
              Digite o código SGG da empresa para realizar o vínculo manual:
            </p>
            <Input
              placeholder="Código SGG"
              value={sgg_id}
              onChange={(e) => setSgg_id(e.target.value)}
            />
          </div>
        </Modal>
      )}
      {user?.type === "tecnico" && (
        <Modal
          title="Vincular Código SGG ao Setor"
          open={visibleModalLinkSector}
          onOk={linkSector}
          onCancel={() => setVisibleModalLinkSector(false)}
          confirmLoading={integrating === "link-sector"}
          okText="Vincular"
          cancelText="Cancelar"
        >
          <div style={{ padding: "20px 0" }}>
            <p>
              Digite o código SGG do setor "{activeSector?.name}" para realizar
              o vínculo manual:
            </p>
            <Input
              placeholder="Código SGG"
              value={sgg_id}
              onChange={(e) => setSgg_id(e.target.value)}
            />
          </div>
        </Modal>
      )}
      {user?.type === "tecnico" && (
        <Modal
          title="Solicitar Alteração do Formulário"
          open={visibleModalAlteration}
          onOk={requestAlteration}
          onCancel={() => setVisibleModalAlteration(false)}
          confirmLoading={requestingAlteration}
          okText="Solicitar"
          cancelText="Cancelar"
          okButtonProps={{ disabled: !observation || !observation.trim() }}
        >
          <div style={{ padding: "20px 0" }}>
            <p style={{ marginBottom: 10 }}>
              Digite as observações/correções necessárias para o preenchimento
              do formulário:
            </p>
            <Input.TextArea
              rows={4}
              placeholder="Descreva aqui o que o franqueado precisa alterar..."
              value={observation}
              onChange={(e) => setObservation(e.target.value)}
            />
          </div>
        </Modal>
      )}
    </Container>
  );
}
